import { FileText as CommandIcon } from "lucide-react";
import { useParams } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/atomic/DropdownMenu";
import { useCommands } from "@/hooks/agent/useCommands";
import { cn } from "@/lib/utils";
import { Command } from "@/models/agent/command";

interface CommandSelectorProps {
  onSelect: (command: Command | null) => void;
  disabled?: boolean;
}

export const CommandSelector: React.FC<CommandSelectorProps> = ({
  onSelect,
  disabled = false,
}) => {
  const { workspaceId } = useParams();
  const { commands, isLoading } = useCommands(workspaceId || null);

  if (!isLoading && (!commands || commands.length === 0)) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          "h-8 w-8 p-0 text-gray-400 hover:text-gray-600 rounded-md hover:bg-gray-100 inline-flex items-center justify-center transition-colors",
          disabled && "opacity-50 cursor-not-allowed pointer-events-none",
        )}
      >
        <CommandIcon className="h-4 w-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" side="bottom" className="max-w-250 max-h-96 overflow-y-auto">
        {isLoading && <div className="p-4 text-center text-gray-500">Loading...</div>}
        {!isLoading && commands.map((command) => (
          <DropdownMenuItem
            key={command.id}
            onClick={() => onSelect(command)}
            className="flex-col items-start py-2 cursor-pointer gap-1"
          >
            <div className="font-medium text-gray-900 w-full truncate">{command.name}</div>
            <div className="text-xs text-gray-500 w-full truncate">{command.description}</div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
